<template>
  <div>
    <div class="position-absolute handover-top-container">
      <p class="secondary--text position-relative font-weight-normal">
        Filter By
      </p>
      <div class="d-flex">
        <b-form-group class="mr-3" v-if="assistantsList">
          <b-form-select
            v-model="selectedAssignedTo"
            @change="onChangeAssignedTo"
            :options="[{ text: 'Assigned to', value: null }, ...assistantsList]"
          ></b-form-select>
        </b-form-group>

        <b-form-group class="mr-3" v-if="assistantsList">
          <b-form-select
            v-model="selectedRequestedBy"
            @change="onChangeRequestedBy"
            :options="[
              { text: 'Requested by', value: null },
              ...assistantsList
            ]"
          ></b-form-select>
        </b-form-group>

        <b-form-group class="mr-3">
          <b-form-select
            v-model="selectedStatus"
            @change="statusChange"
            :options="statuses"
          ></b-form-select>
        </b-form-group>

        <b-form-group class="mr-0 filter-by-form-group-2">
          <b-form-select
            v-model="selectedCustomer"
            @change="customerChange"
            :options="customerNames"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="toggle-handover-status-container mt-10">
        <span>Completed Handovers</span>
        <toggle-button
          class="mr-4"
          @change="onToggleHandoverState"
          :value="!showActiveHandovers"
          color="#09374b"
        ></toggle-button>
      </div>
    </div>
    <b-row class="handover-card-row mx-0 mt-5 mb-1">
      <b-col class="px-3 py-2 handover-card-column d-flex">
        <b-col md="2" class="pl-0 pr-4">
          <p class="primary--text font-family-medium">Customer name</p>
        </b-col>
        <b-col md="2" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Task</p>
        </b-col>
        <b-col md="1" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Due date</p>
        </b-col>
        <b-col md="3" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Assign to</p>
        </b-col>
        <b-col md="2" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Requested by</p>
        </b-col>
        <b-col md="1" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Created At</p>
        </b-col>
        <b-col md="1" class="pl-2 pr-4">
          <p class="primary--text font-family-medium">Status</p>
        </b-col>
      </b-col>
    </b-row>
    <b-row class="mx-0">
      <b-col
        md="12"
        xl="12"
        lg="12"
        class="py-2 px-2 handover-card-column w-100"
      >
        <b-card
          no-body
          @click="$router.push({ path: `/task/${task.task.id}` })"
          v-for="(task, index) in taskList"
          :key="index"
          class="mb-2"
        >
          <b-card-body
            class="px-2 py-2 d-flex align-items-center"
            @mouseenter="showHover(index)"
            @mouseleave="hideHover"
          >
            <b-col md="2" class="pl-0 pr-4 d-flex align-items-center">
              <b-avatar
                v-if="task.task.created_for.avatar_thumbnail"
                size="4.4rem"
                :src="task.task.created_for.avatar_thumbnail"
              ></b-avatar>
              <b-avatar
                v-else
                size="4.4rem"
                class="customer-avatar bg--primary"
                :text="customerInitials(task.task.created_for)"
              ></b-avatar>
              <h6 class="font-sm font-family-medium primary--text ml-3">
                {{
                  ellipsify(
                    `${task.task.created_for.first_name} ${task.task.created_for.last_name}`, 30
                  )
                }}
              </h6>
            </b-col>
            <b-col md="2" class="pl-2 pr-4">
              <h6 class="font-sm primary--text font-family-medium">
                {{
                  task.task.title.length > 25
                    ? `${task.task.title.substring(0, 22)}...`
                    : task.task.title
                }}
              </h6>
              <h6
                class="font-sm secondary--text font-weight-normal reduce-whitespace-2"
              >
                {{ trimDescription(task.task.description) }}
              </h6>
            </b-col>
            <b-col md="1" class="pl-2 pr-4">
              <h6 class="font-sm primary--text font-family-regular">
                {{
                  task.task.due_date
                    ? getFormattedDate(task.task.due_date)
                    : "N/A"
                }}
              </h6>
            </b-col>
            <b-col md="3" class="pl-2 pr-4">
              <multiselect
                :value="task.assigned_to"
                @select="getSelectedAssistant($event, index)"
                class="custom-multiselect multiselect-handover"
                selectLabel=""
                :disabled="task.status === 'accepted'"
                :class="[
                  task.status === 'accepted' ? 'multiselect-disabled' : null
                ]"
                deselectLabel=""
                selectedLabel=""
                :options="assistantsList"
                track-by="id"
                placeholder="Assign to"
                :custom-label="customLabel"
              >
                <template slot="noResult">No PAs found</template>
                <template slot="noOptions">No PAs found</template>
                <template slot="caret">
                  <img
                    class="custom-caret"
                    src="@/assets/icons/dropdown_arrow.svg"
                    alt=""
                  />
                </template>
              </multiselect>
            </b-col>
            <b-col md="2" class="pl-2 pr-4 align-items-center d-flex">
              <b-avatar
                v-if="task.requested_by.avatar_thumbnail"
                size="4.4rem"
                :src="task.requested_by.avatar_thumbnail"
              ></b-avatar>
              <b-avatar
                v-else
                size="4.4rem"
                class="customer-avatar bg--primary"
                :text="customerInitials(task.requested_by)"
              ></b-avatar>
              <h6 class="font-sm font-family-medium primary--text ml-3">
                {{
                  task.requested_by.fullName.length > 15
                    ? `${task.requested_by.fullName.substring(0, 15)}...`
                    : task.requested_by.fullName
                }}
              </h6>
            </b-col>
            <b-col md="1" class="pl-2 pr-4">
              <h6 class="font-sm primary--text font-family-regular">
                {{ task.created ? getFormattedDate(task.created) : "N/A" }}
              </h6>
            </b-col>
            <b-col md="1" class="pl-2 pr-4">
              <h6
                class="font-sm primary--text font-family-regular text-capitalize"
              >
                {{ task.status === "noaction" ? "Pending" : task.status }}
              </h6>
            </b-col>
          </b-card-body>
        </b-card>
         <div v-if="loading" class=" loading-message">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            <b-spinner />
          </h4>
        </div>
        <div v-else class=" loading-message">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more tasks to load.
          </h4>
        </div>
      </b-col>
      <b-modal
        id="delete-checklist-modal"
        v-model="showSelectionModal"
        body-class="delete-checklist-modal-body"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
      >
        <div v-if="isAssign">
          <h1 class="font-lg">Are you sure?</h1>
          <h3 class="subtext mb-4 mt-3 ml-2 font-lg">
            {{
              taskList[assignAssistantIndex].status === "rejected" &&
              taskList[assignAssistantIndex].assigned_to.id ===
                assignAssistant.id
                ? `${assignAssistant.user.firstName} ${assignAssistant.user.lastName} has rejected this handover request earlier. 
                  Do you want to continue?`
                : `Do you want to handover the task to the following ${
                    assignAssistant.role.name === "admin" ? "admin" : "EA"
                  } ?`
            }}
          </h3>
          <b-row align-v="center">
            <b-col class="flex-row d-flex mb-4">
              <div>
                <b-avatar
                  v-if="assignAssistant.user.avatar_thumbnail"
                  size="8rem"
                  :src="assignAssistant.user.avatar_thumbnail"
                ></b-avatar>
                <b-avatar
                  v-else
                  size="8rem"
                  class="bg--primary"
                  :text="customerInitials({
                    first_name: assignAssistant.user.firstName,
                    last_name: assignAssistant.user.lastName,
                   })"
                ></b-avatar>
              </div>
              <div
                class="d-flex flex-column justify-content-center position-relative ml-4"
              >
                <p class="font-family-medium primary--text">
                  {{ `${assignAssistant.user.firstName} ${assignAssistant.user.lastName}` }}
                </p>
                <p
                  class="secondary--text reduce-whitespace"
                  v-if="assignAssistant.role.name !== 'admin'"
                >
                  {{ assignAssistant.assistantProfile.workHours }} hours/week
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="
              taskList[assignAssistantIndex].status === 'rejected' &&
                taskList[assignAssistantIndex].assigned_to.id ===
                  assignAssistant.id
            "
            class="d-flex justify-content-start pl-4 mt-2 mr-3"
          >
            <p class="primary--text">
              {{ `Reason: ${taskList[assignAssistantIndex].reason}` }}
            </p>
          </b-row>
          <b-row class="mt-3">
            <div class="buttons-row">
              <div class="buttons-wrapper">
                <div class="button-wrapper">
                  <b-button @click="handoverPAToClient" class="accept-button">
                    Yes, Assign
                  </b-button>
                </div>
                <div class="button-wrapper">
                  <b-button
                    class="cancel-button"
                    @click="showSelectionModal = false"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </div>
          </b-row>
        </div>
      </b-modal>
      <b-modal
        id="delete-checklist-modal"
        v-model="showAuthError"
        body-class="delete-checklist-modal-body"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
      >
        <h1 class="font-lg">Unable to delete request</h1>

        <h3 class="font-lg">
          {{ authMessage }}
        </h3>
        <div class="buttons-row">
          <div class="buttons-wrapper">
            <div class="button-wrapper">
              <b-button class="cancel-button" @click="reloadPage"
                >Cancel</b-button
              >
            </div>
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import {
  getAdmins,
  getAssistantsList,
  updateHandOverTask
} from "@/apis/assistants";
import { getTaskStatus } from "@/apis/common";
import moment from "moment";
import { ellipsify } from "@/utils/utils";
import { collection, query, onSnapshot, where } from "firebase/firestore";
import _ from "lodash"
import { db, firebaseConfig } from "@/config/firestore"

export default {
  name: "HandoverToOthersAdmin",
  components: {
    Multiselect
  },
  data() {
    return {
      offset: 0,
      infiniteId: +new Date(),
      showSelectionModal: false,
      loading: false,
      isAssign: false,
      isUnassign: false,
      showUnselectionModal: false,
      assignAssistant: {},
      assignAssistantIndex: null,
      selectedAssistant: [],
      taskList: [],
      expandHover: false,
      showAuthError: false,
      activeHoverID: "",
      authMessage: "",
      count: null,
      assistantsList: [],
      paNames: [],
      customerNames: [],
      statuses: [],
      isLoading: true,
      selectedAssignedTo: null,
      selectedRequestedBy: null,
      selectedCustomer: null,
      selectedStatus: null,
      showActiveHandovers: true,
    };
  },
  mounted() {
    getTaskStatus()
      .then(res => {
        this.statuses = [...res.data.results].map(item => {
          return {
            text: item.title,
            value: item.id
          };
        });
        this.statuses.unshift({
          value: null,
          text: "Task Status"
        });
      })
      .catch(err => console.log(err));

    
    getAssistantsList().then(res => {
      this.assistantsList = [...this.assistantsList, ...res.data.results]
        .filter(el => el.id !== this.profileUserId)
        .map(item => {
          item.text = `${item.user.firstName} ${item.user.lastName}`;
          item.value = item.id;
          return item;
        });
    });
    getAdmins().then(res => {
      this.assistantsList = [...this.assistantsList, ...res.data.results]
        .filter(el => el.id !== this.profileUserId)
        .map(item => {
          item.text = `${item.user.first_name} ${item.user.last_name}`;
          return item;
        });
    });
    this.loadTasks()
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    customLabel({ first_name, last_name, text, user }) {
      if (user) {
        let { firstName, lastName } = user
        return `${firstName} ${lastName}`
      }
      if (text) {
        return text
      }
      return `${first_name} ${last_name}`
    },
    changeData() {
      this.loadTasks()
    },
    loadTasks() {
      this.loading = true
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      const params = [
        // commenting out this line because we have decided to show all handover requests to the admin
        // where('requested_by.id', '==', this.profileUserId),
      ]
      if (this.selectedAssignedTo) {
        params.push(where("assigned_to.id", "==", this.selectedAssignedTo));
      }
      if (this.selectedRequestedBy) {
        params.push(where("requested_by.id", "==", this.selectedRequestedBy));
      }
      if (this.selectedStatus) {
        let status = (this.statuses.find(status => status.value === this.selectedStatus)).text
        params.push(where('task.status', '==', status))
      }
      if (this.selectedCustomer) {
        params.push(where('task.created_for.id', '==', this.selectedCustomer))
      }
      if (this.showActiveHandovers) {
        params.push(where("status", "in", ["rejected", "noaction"]));
      }
      else {
        params.push(where("status", "==", "accepted"));
      }

      const handoversRef = collection(db, firebaseConfig.collectionName)
      const q = query(handoversRef, ...params);
      this.unsubscribe = onSnapshot(q, (querySnapshot) => {
        const taskList = [];
        querySnapshot.forEach((doc) => {
            taskList.push({
              ...doc.data(),
              id: doc.id
            });
        });
        this.selectedAssistant = taskList.map((item) => {
          item.requested_by.fullName = `${item.requested_by.first_name} ${item.requested_by.last_name} `;
          if (item.status !== "rejected") {
            item.text = `${item.assigned_to.first_name} ${item.assigned_to.last_name}`;
            return item.assigned_to
          } else {
            return { text: "Assign to", id: null }
          }
        });
        this.taskList = taskList
        this.loading = false
        this.populateCustomers()
      });
    },
    populateCustomers() {
      let customerNames = []
      for (let task of this.taskList) {
        let customer = task.task.created_for
        customerNames.push({
          value: customer.id,
          text: `${customer.first_name} ${customer.last_name}`
        })
      }
      customerNames.sort((a, b) => a.text < b.text ? -1: 1)
      customerNames.unshift({
        value: null,
        text: 'Customer'
      })
      this.customerNames = _.uniqBy(customerNames, 'value')
    },
    trimDescription(description) {
      let des = description.replace(/<(.|\n)*?>/g, " ").trim();
      if (des.length > 20) {
        return `${des.substring(0, 17)}...`;
      } else if (des.length > 0) {
        return des;
      } else {
        return "...";
      }
    },
    reloadPage() {
      this.showAuthError = false;
      this.$router.go();
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    showHover(index) {
      this.expandHover = true;
      this.activeHoverID = this.taskList[index].id;
    },
    hideHover() {
      this.expandHover = false;
      this.activeHoverID = "";
    },
    getSelectedAssistant(selected, index) {
      this.showSelectionModal = true;
      this.isAssign = true;
      this.isUnassign = false;
      this.assignAssistant = selected;
      this.assignAssistantIndex = index;
    },

    infiniteHandlerHandoverTasks($state) {
      $state.complete()
    },
    onChangeAssignedTo() {
      this.changeData();
    },
    onChangeRequestedBy() {
      this.changeData();
    },
    statusChange() {
      this.changeData();
    },
    customerChange() {
      this.changeData();
    },
    handoverPAToClient() {
      this.selectedAssistant[this.assignAssistantIndex] = this.assignAssistant;
      const requestID = this.taskList[this.assignAssistantIndex].id;
      const data = {
        task: this.taskList[this.assignAssistantIndex].task.id,
        requestedBy: this.profileUserId,
        assignedTo: this.assignAssistant.id,
        status: "noaction"
      };
      updateHandOverTask(requestID, data)
        .then(() => {})
        .catch(err => {
          console.log(err);
          this.showAuthError = true;
          this.authMessage = err.response.data.detail;
        });

      this.showSelectionModal = false;
    },
    // unassignPAToClient(selected,index) {
    //   this.showSelectionModal = true;
    //   this.isAssign = false;
    //   this.isUnassign = true;
    // },
    // removePA() {
    //   this.selectedAssistant[this.assignAssistantIndex] = {
    //     text: "Assign to",
    //     id: null,
    //   };
    //   this.showSelectionModal = false;
    // },
    ellipsify,
    customerInitials(user) {
      let fullName = `${user.first_name} ${user.last_name}`;
      return fullName.match(/\b(\w)/g).join("");
    },
    onToggleHandoverState(data) {
      this.showActiveHandovers = !data.value;
      this.changeData();
    }
  },
  computed: {
    ...mapState("authModule", ["role", "profileUserId"])
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style scoped lang="scss">
.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none !important;
}
.custom-caret {
  position: absolute;
  right: 0.8rem;
  bottom: 1.5rem;
  z-index: 2;
}
.modal-padding {
  padding: 20rem;
}
.handover-top-container {
  top: -9.5rem;
  right: 0;
  z-index: 2;
}
.card {
  cursor: pointer;
}
.loading-message {
  text-align: center;
  width: 100%;
}
</style>
